import axios from "axios"
import { getOrStartRefresh } from './authRefresh'

const $AgentsServiceAxios = axios.create({
  baseURL: process.env.VUE_APP_AGENTS_API_URL || 'http://localhost:8888',
  timeout: process.env.NODE_ENV === 'development' ? 600000 : 1200000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
})

// Normalize rejections to the { error, errors } shape the rest of the app
// expects (mirrors src/plugins/axios.js), so agents-service call sites don't
// have to special-case raw axios errors.
function normalizeError(error) {
  const errors = []
  const data = error.response && error.response.data
  if (data instanceof Object) {
    for (const key in data) {
      if (key === 'success' && data[key] === false) continue
      errors.push(key + '.' + data[key])
    }
  } else if (data && data.message) {
    errors.push(data.message)
  }
  if (!errors.length) {
    errors.push(error.message || 'Request failed')
  }
  return { error, errors }
}

$AgentsServiceAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config
    if (error.response?.status === 401 && config && !config._retry) {
      return getOrStartRefresh()
        .then(() => {
          config._retry = true
          return $AgentsServiceAxios.request(config)
        })
        .catch((retryErr) => Promise.reject(normalizeError(retryErr.response ? retryErr : error)))
    }
    return Promise.reject(normalizeError(error))
  }
)

export default $AgentsServiceAxios

